module.exports = __webpack_public_path__ + "static/media/lever-coin.1fcc0b7c.webp";